import { KEYS } from './constants-keys';

export const APP_ENV_TYPE = {
  DEV: 'development',
  STAGE: 'staging',
  PROD: 'production',
};

const AppConfig = {
  ENV: APP_ENV_TYPE.PROD,
  // API_SERVER: 'https://extern-api.apoc.day/api',
  API_SERVER: 'https://extern-api.apoc.day/api',
  KEYS,
  PAGING_ROW: 20,
  // 아래는 nie 관련 constants 값들
  KAKAO_TEMPLATE_TOKEN: 'UjVhVkhUaXlyT3hJY1I3ZU1MeWRGaXh2bWxncno2amZkcVEwMldqSHRYSlUxVGhkTWFjclNob094M3daUWZEbw',
};
export default AppConfig;
